import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  TemplateRef,
} from '@angular/core';
import { AsyncPipe, CommonModule, NgTemplateOutlet } from '@angular/common';
import { TableModule } from 'primeng/table';
import { IColumn } from './table.model';
import { SkeletonModule } from 'primeng/skeleton';
import { PaginatorModule } from 'primeng/paginator';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguagePipe } from '../../pipes/language.pipe';
import { GetTableDataService } from '../../services';
import { PermissionDirective } from '../../directives';
import { TableNumberFormatPipe } from './table-number-format.pipe';
@Component({
  selector: 'lib-table',
  imports: [
    CommonModule,
    TableModule,
    SkeletonModule,
    PaginatorModule,
    NgTemplateOutlet,
    TranslocoModule,
    LanguagePipe,
    AsyncPipe,
    PermissionDirective,
    TableNumberFormatPipe,
  ],
  templateUrl: './table.html',
  styleUrls: ['./table.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Table<T> {
  /**
   *
   */
  constructor() {
    effect(() => {
      const data = this.inputData();
      if (data) {
        this.$getTable.isLoading.set(false);
        const currentFirst = this.$getTable.first();
        if (!data.length || currentFirst >= data.length) {
          this.$getTable.first.set(0);
        }
      }
    });
  }

  protected $getTable = inject(GetTableDataService);

  customColumn = input<TemplateRef<unknown>>();

  filter = input<TemplateRef<unknown>>();

  column = input.required<IColumn<T>[]>();

  actionColumn = input<TemplateRef<unknown>>();

  actionColumnHeader = input<string>('action_column');

  permissions = input<string[]>();

  inputData = input<unknown[]>();
}
